export const RegexNumber = /^\d+$/;
export const RegexPhoneNumber = /\+?([ -]?\d+)+|\(\d+\)([ -]\d+)/;
export const RegexUsername = new RegExp(/^(?=.*[A-Za-z])[A-Za-z\d_.]{6,}$/);
export const RegexPassword = new RegExp(
  /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/
);
export const RegexKTP = new RegExp(
  /^(1[1-9]|21|[37][1-6]|5[1-3]|6[1-5]|[89][12])\d{2}\d{2}([04][1-9]|[1256][0-9]|[37][01])(0[1-9]|1[0-2])\d{2}\d{4}$/
);
